<template>
  <div class="beneficio-card">
    <div class="icon">
      <v-icon size="12" color="primary">mdi-heart-pulse</v-icon>
    </div>
    <div class="text">
      <div class="title">
        Mais saúde para você
      </div>
      <div class="description">
        Um conjunto de ofertas especiais para você cuidar da sua saúde
      </div>
    </div>
    <div>
      <v-img class="mx-2" src="@/assets/icon-healthy.png" max-width="100" width="70px" contain></v-img>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BeneficiosList'
}
</script>

<style scoped>
.beneficio-card {
  display: flex;
  flex-direction: row;
  height: 110px;
  background-color: #fff;
  padding: 20px 20px;
  border-radius: 10px;
  color: #818181;
  overflow: hidden;
}
.title {
  font-weight: 600;
  flex-wrap: wrap;
  font-size: 0.95rem !important;
}
.text {
  display: flex;
  flex-direction: column;
  width: 80%;
  flex-wrap: wrap;
}
.description {
  font-size: 0.7rem;
  white-space: normal;
}
.icon {
  background-color: #f7f7f7;
  /* background-color: #771414; */
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -15px;
  margin-left: -15px;
}
@media only screen and (min-width: 960px) {
  .description {
    font-size: 0.8rem !important;
  }
}
</style>
